<!-- Inline Chat Section -->
<div class="chat-container" [class.expanded]="isExpanded">
  
  <!-- Chat Header -->
  <div class="chat-header">
    <div class="chat-title" (click)="togglePreviewExpansion()">
      <i class="pi pi-comments"></i>
      <span>Chat</span>
      <span class="unread-badge" *ngIf="unreadCount > 0" [title]="'Unread: ' + unreadCount">{{ unreadCount }}</span>
    </div>
    <div class="chat-actions">
      <button class="action-btn" 
              (click)="togglePreviewExpansion(); $event.stopPropagation()"
              [pTooltip]="isExpanded ? 'Collapse Chat' : 'Expand Chat'"
              tooltipPosition="top"
              type="button">
        <i class="pi" [class.pi-chevron-down]="isExpanded" [class.pi-chevron-up]="!isExpanded"></i>
      </button>
    </div>
  </div>

  <!-- Chat Messages -->
  <div class="chat-messages" #chatHistoryScroll>
    <div *ngIf="messages.length === 0" class="no-messages">
      <i class="pi pi-comments"></i>
      <p>No messages yet. Start the conversation!</p>
    </div>
    
    <div *ngFor="let message of messages" 
         class="chat-message"
         [class.self]="message.isSelf"
         [class.other]="!message.isSelf">
      <div class="message-container">
        <div class="message-meta">
          <span class="message-sender-bubble">{{ message.senderName }}</span>
          <span class="message-time-bubble">{{ getFormattedTime(message) }}</span>
        </div>
        <span class="message-text">{{ message.message }}</span>
      </div>
    </div>
  </div>

  <!-- Chat Input - Pinned to Bottom -->
  <div class="chat-input-footer">
    <div class="chat-input-container">
      <input 
        type="text" 
        pInputText 
        [(ngModel)]="newMessage"
        (keypress)="onKeyPress($event)"
        placeholder="Type your message..."
        class="chat-input">
      <p-button 
        icon="pi pi-send" 
        (onClick)="sendMessage()"
        [disabled]="!newMessage.trim()"
        styleClass="send-button">
      </p-button>
    </div>
  </div>
</div>

